<template>
  <validation-observer ref="provider-general-info-form">
    <div class="row">
      <div class="col">
        <label>SSN Patronal:</label>
        <p>{{ providerInfo.ssn }}</p>
      </div>

      <div class="col">
        <validation-provider
          v-slot="{ errors }"
          :custom-messages="{ required: 'Campo Requerido' }"
          :rules="!disabled ? 'required' : null"
        >
          <custom-drop-down
            v-model="model.type"
            :clearable="false"
            :custom-error-msg="errors[0]"
            :disabled="
              (providerInfo.primaryProvider.ssn != null ||
                proposalInfo != null ||
                disabled) &&
                !isDirectPay
            "
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Proveedor:"
            :options="companyTypesOptions"
          />
        </validation-provider>
      </div>

      <div class="col">
        <validation-provider
          v-slot="{ errors }"
          :custom-messages="{ required: 'Campo Requerido' }"
          :rules="!disabled ? 'required' : null"
        >
          <div class="color-gray-6 font-14 mb-2">Nombre:</div>
          <custom-input
            v-model="model.name"
            :class="{
              'ml-n3': proposalInfo != null,
            }"
            :custom-error-msg="errors[0]"
            :disabled="proposalInfo != null || disabled"
            :error="errors[0]"
          />
        </validation-provider>
      </div>

      <template v-if="providerInfo.primaryProvider.ssn === null">
        <section-title
          class="col-12 mt-2 mb-2"
          :has-line="false"
          :title="'Información General'"
        />
        <div class="col">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{ required: 'Campo Requerido' }"
            :rules="!disabled ? 'url' : null"
          >
            <custom-input
              v-model="model.website"
              :custom-error-msg="errors[0]"
              :disabled="disabled"
              :error="errors[0]"
              label="Dirección Web:"
              :placeholder="'www.websitedomain.com'"
            />
          </validation-provider>
        </div>

        <div class="col">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{ required: 'Campo Requerido' }"
            :rules="!disabled ? 'required' : null"
          >
            <custom-input
              v-model="model.phone"
              :custom-error-msg="errors[0]"
              :disabled="disabled"
              :error="errors[0]"
              label="Teléfono:"
              mask-type="Phone"
              placeholder="(___) ___-____"
            />
          </validation-provider>
        </div>

        <div class="col">
          <custom-input
            v-model="model.fax"
            :disabled="disabled"
            label="Fax:"
            :mask-type="'Phone'"
            placeholder="(___) ___-____"
          />
        </div>
        <div v-if="!isIndividualCompany" class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              v-model="model.profitType"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
              is-inline
              label="Tipo de Proveedor:"
              name="profitType"
              :options="profitTypeOptions"
            />
          </validation-provider>
        </div>
        <div class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.rupNumber"
              :custom-error-msg="errors[0]"
              :error="errors[0]"
              label="Número de RUP:"
              type="number"
            />
          </validation-provider>
        </div>
      </template>
      <template v-if="providerInfo.primaryProvider.ssn != null">
        <div class="col-12 d-flex flex-column mt-3">
          <strong>
            Compañía Primaria:
          </strong>
          <span class="font-weight-normal">
            {{ providerInfo.primaryProvider.name }}
          </span>
        </div>
      </template>
    </div>
    <div
      v-if="providerInfo.primaryProvider.ssn === null && isIndividualCompany"
      class="row"
    >
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="model.specialty"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Especialidad:"
            maxlength="100"
          />
        </validation-provider>
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="model.licenseNumber"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Número de Licencia:"
            maxlength="50"
          />
        </validation-provider>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomRadio from '@/components/common/CustomRadio';
import { mapActions, mapState } from 'vuex';
import { name } from '@/modules/provider/store';
import companyTypes from '@/utils/constants/companyTypes.js';

export default {
  name: 'ProviderGeneralInfoForm',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomInput,
    CustomRadio,
  },
  props: {
    providerInfo: {
      type: Object,
      default: () => ({
        ssn: null,
        providerType: null,
        name: null,
        isServiceRequestCompany: false,
        isIncorporatedCompany: false,
      }),
      required: true,
    },
    mainProviderInfo: {
      type: Object,
      default: () => ({
        ssn: null,
        providerType: null,
        name: null,
        $_default: true,
      }),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    valid: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    proposalInfo: {
      type: Object,
      default: () => null,
    },
  },
  data: () => ({
    model: {
      type: null,
      name: null,
      website: null,
      phone: null,
      fax: null,
      rupNumber: '',
      profitType: '',
      specialty: '',
      licenseNumber: '',
    },
    catalog: {
      providerTypes: [],
    },
    profitTypeOptions: [
      { value: 1, label: 'Con Fines de Lucro' },
      { value: 2, label: 'Sin Fines de Lucro ' },
    ],
  }),
  computed: {
    hasMainCompany() {
      return !this.mainProviderInfo.$_default;
    },
    isIndividualCompany() {
      return this.model.type?.id == companyTypes.Individual;
    },
    ...mapState(name, ['companyTypes']),
    companyTypesOptions() {
      const items =
        this.providerInfo.primaryProvider.providerType ==
        companyTypes.DirectPaymentInstitutions
          ? this.companyTypes.filter(
              (x) => x.id == companyTypes.DirectPaymentInstitutions
            )
          : this.companyTypes;
      return items;
    },
    isDirectPay() {
      return (
        this.providerInfo.primaryProvider.providerType ==
        companyTypes.DirectPaymentInstitutions
      );
    },
  },
  watch: {
    'catalog.providerTypes'() {
      if (!this.disabled) {
        if (this.providerInfo.primaryProvider.ssn != null) {
          this.model.type = this.companyTypesOptions.find(
            (x) => x.id == this.providerInfo.primaryProvider.providerType
          );
        }
      }
    },
    proposalInfo: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal) {
            this.model = {
              ...this.model,
              type: newVal.providerType,
              name: newVal.providerName,
              phone: newVal.telephoneNumber,
            };
          }
        }
      },
    },
  },
  async created() {
    this.catalog.providerTypes = await this.getCompanyTypes();
  },
  methods: {
    ...mapActions(name, ['getCompanyTypes']),
    async validate() {
      const valid = await this.$refs['provider-general-info-form'].validate();
      const data = valid ? this.model : {};

      this.$emit('update:data');
      this.$emit('update:valid', valid);

      return { data, valid };
    },
    reset() {
      this.$refs['provider-general-info-form'].reset();
    },
  },
};
</script>
